<div class="content">

    <!-- Begin dashboard -->
    <div class="container-fluid" style="max-height: 860px;">

        <!-- Page Heading -->
        <div class="row">
            <div class="col d-sm-flex align-items-center justify-content-between mb-4">
                <h1 class="dashboard-title">User Work List</h1>
            </div>

        </div>


<!-- =====================================================
     USER WORK LIST TOOLBAR
     ===================================================== -->
<div class="row align-items-center user-work-list-toolbar">

  <!-- SEARCH -->
  <div class="col-lg-10 col-md-9 col-sm-12 user-work-search-column">

    <div class="google-search-container">

      <i class="fa fa-search search-icon"></i>

      <input
        (keyup.enter)="onSearch()"
        (input)="onSearchInput(searchBox.value)"
        #searchBox
        class="google-search-input"
        type="text"
        placeholder="Search"
      />

      <i
        *ngIf="searchBox.value"
        class="fa fa-times clear-icon"
        (click)="clearSearch(searchBox)">
      </i>

    </div>

  </div>


  <!-- ACTIONS -->
  <div class="col-lg-2 col-md-3 col-sm-12 user-work-actions-column">

    <div class="user-work-action-bar">


      <!-- FILTER -->
      <div
        class="user-work-filter-wrapper"
        #filterDropdown>

        <button
          type="button"
          class="
            listing-btn
            listing-btn-secondary
            listing-filter-btn
          "
          [class.active]="showDateFilter"
          (click)="toggleDateFilter()"
          #filterBtn
          title="Filters">

          <i class="fa-solid fa-sliders"></i>

          <span class="listing-btn-label">
            Filters
          </span>

          <span
            *ngIf="activeFilterCount > 0"
            class="listing-filter-count">

            {{ activeFilterCount }}

          </span>

        </button>


        <!-- FILTER POPOVER -->
        <div
          *ngIf="showDateFilter"
          class="user-work-filter-popover"
          (click)="$event.stopPropagation()">


          <!-- HEADER -->
          <div class="user-work-filter-header">

            <div>

              <div class="user-work-filter-title-row">

                <span class="user-work-filter-title">
                  Filters
                </span>

                <span
                  *ngIf="activeFilterCount > 0"
                  class="user-work-filter-active-badge">

                  {{ activeFilterCount }} Active

                </span>

              </div>

              <div class="user-work-filter-subtitle">
                Filter the work list by status, benefit type and date range.
              </div>

            </div>


            <button
              type="button"
              class="user-work-filter-close"
              (click)="toggleDateFilter()"
              title="Close">

              <i class="fa-solid fa-xmark"></i>

            </button>

          </div>


          <!-- BODY -->
          <div class="user-work-filter-body">


            <!-- ==========================================
                 STATUS
                 ========================================== -->
            <div class="user-work-filter-section">

              <div class="user-work-filter-section-heading">

                <span class="user-work-filter-section-icon">
                  <i class="fa-solid fa-circle-check"></i>
                </span>

                <div>

                  <div class="user-work-filter-section-title">
                    Status
                  </div>

                  <div class="user-work-filter-section-hint">
                    Choose which patient records to display.
                  </div>

                </div>

              </div>


              <div class="user-work-filter-status-grid">

                <!-- ALL -->
                <button
                  type="button"
                  class="user-work-filter-choice"
                  [class.active]="selectedStatusFilter === 'all'"
                  (click)="setFilterType('all')">

                  <i class="fa-solid fa-list"></i>

                  <span>
                    All
                  </span>

                </button>


                <!-- ACTIVE -->
                <button
                  type="button"
                  class="user-work-filter-choice"
                  [class.active]="selectedStatusFilter === 'active'"
                  (click)="setFilterType('active')">

                  <i class="fa-solid fa-circle-check"></i>

                  <span>
                    Active
                  </span>

                </button>


                <!-- INACTIVE -->
                <button
                  type="button"
                  class="user-work-filter-choice"
                  [class.active]="selectedStatusFilter === 'inactive'"
                  (click)="setFilterType('inactive')">

                  <i class="fa-solid fa-circle-xmark"></i>

                  <span>
                    Inactive
                  </span>

                </button>

              </div>

            </div>


            <!-- PATIENT BENEFIT DOMAIN -->
            <div class="user-work-filter-section">
              <div class="user-work-filter-section-heading">
                <span class="user-work-filter-section-icon"><i class="fa-solid fa-notes-medical"></i></span>
                <div>
                  <div class="user-work-filter-section-title">Patient Benefit Type</div>
                  <div class="user-work-filter-section-hint">Filter by Dental, Medical, or Both coverage.</div>
                </div>
              </div>
              <div class="user-work-filter-status-grid" role="group" aria-label="Patient benefit type">
                <button type="button" class="user-work-filter-choice"
                        [class.active]="selectedPatientBenefitType === 'DENTAL'"
                        [attr.aria-pressed]="selectedPatientBenefitType === 'DENTAL'"
                        (click)="selectedPatientBenefitType = 'DENTAL'">Dental</button>
                <button type="button" class="user-work-filter-choice"
                        [class.active]="selectedPatientBenefitType === 'MEDICAL'"
                        [attr.aria-pressed]="selectedPatientBenefitType === 'MEDICAL'"
                        (click)="selectedPatientBenefitType = 'MEDICAL'">Medical</button>
                <button type="button" class="user-work-filter-choice"
                        [class.active]="selectedPatientBenefitType === 'BOTH'"
                        [attr.aria-pressed]="selectedPatientBenefitType === 'BOTH'"
                        (click)="selectedPatientBenefitType = 'BOTH'">Both</button>
              </div>
            </div>

            <!-- ==========================================
                 DATE RANGE
                 ========================================== -->
            <div class="user-work-filter-section">

              <div class="user-work-filter-section-heading">

                <span class="user-work-filter-section-icon">
                  <i class="fa-regular fa-calendar"></i>
                </span>

                <div>

                  <div class="user-work-filter-section-title">
                    Date Range
                  </div>

                  <div class="user-work-filter-section-hint">
                    Optionally limit results to a date range.
                  </div>

                </div>

              </div>


              <div class="user-work-filter-date-grid">


                <!-- START DATE -->
                <div class="user-work-filter-field">

                  <label for="startDate">
                    From
                  </label>

                  <input
                    type="text"
                    id="startDate"
                    class="form-control user-work-filter-input"
                    placeholder="MM/DD/YYYY"
                    bsDatepicker
                    [(ngModel)]="startDate"
                    [bsConfig]="{
                      dateInputFormat: 'MM/DD/YYYY',
                      placement: 'bottom',
                      containerClass: 'theme-blue',
                      adaptivePosition: false
                    }"
                    [maxDate]="todaysDate"
                    (click)="$event.stopPropagation()"
                    (bsValueChange)="onDatepickerShown()"
                  />

                </div>


                <!-- END DATE -->
                <div class="user-work-filter-field">

                  <label for="endDate">
                    To
                  </label>

                  <input
                    type="text"
                    id="endDate"
                    class="form-control user-work-filter-input"
                    placeholder="MM/DD/YYYY"
                    bsDatepicker
                    [(ngModel)]="endDate"
                    [minDate]="startDate"
                    [bsConfig]="{
                      dateInputFormat: 'MM/DD/YYYY',
                      placement: 'bottom',
                      containerClass: 'theme-blue',
                      adaptivePosition: false
                    }"
                    [maxDate]="todaysDate"
                    (click)="$event.stopPropagation()"
                    (bsValueChange)="onDatepickerShown()"
                  />

                </div>

              </div>

            </div>

          </div>


          <!-- FOOTER -->
          <div class="user-work-filter-footer">

            <button
              type="button"
              class="listing-btn listing-btn-secondary"
              (click)="resetFilter()">

              <i class="fa-solid fa-rotate-left"></i>

              Reset

            </button>


            <button
              type="button"
              class="listing-btn listing-btn-primary"
              (click)="applyFilter()">

              <i class="fa-solid fa-check"></i>

              Apply Filters

            </button>

          </div>

        </div>

      </div>

    </div>

  </div>


          <div class="col-xl-12 col-md-12 mb-2">
                    <div class="table-panel p-4">
                      <div class="table-responsive table-scroll-x">
                        <table class="table table-sm" matSort (matSortChange)="sortData($event)">
                          <thead>
                          <tr>
                            <th>Sr.No</th>
                            <!-- <th>
                              <input type="checkbox" [checked]="checked" (click)="assign('All')">
                              <span class="ml-1">Select</span>
                            </th> -->
                            <th>Assigned To</th>
                            <th>Batch-Status</th>
                            <th mat-sort-header="export">Export</th>
                            <th>Verification</th>
                            <th class="audit-review-status-heading">Audit Review</th>
                            <th mat-sort-header="firstName" class="text-left">Name</th>
                            <th mat-sort-header="dob">DOB</th>
                            <th mat-sort-header="patientId">PatientId</th>
                            <th mat-sort-header="formType">Form Type</th>
                            <th mat-sort-header="insuranceType">Ins-Type</th>
                            <th mat-sort-header="payerName">Career Name</th>
                            <th mat-sort-header="careerName">Payer ID</th>
                            <th mat-sort-header="insuranceId">Ins-Id</th>
                            <th mat-sort-header="memberId">Member Id</th>
                            <th mat-sort-header="subscriberDob">Sub-DOB</th>
                            <th mat-sort-header="insurancePhone">Ins-phone</th>
                            <th mat-sort-header="apptDate">App-Date</th>
                            <th mat-sort-header="apptTime">App-Time</th>
                            <th mat-sort-header="providerName">Provider Name</th>
                            <th mat-sort-header="office">Office</th>
                            <th mat-sort-header="groupNo">Grp-No</th>
                            <th mat-sort-header="formFillTime">Timing</th>
                            <th mat-sort-header="active">Status</th>
                            <th>Action</th>
                          </tr>
                          </thead>

                          <tbody *ngIf="tableData?.length">
                          <tr *ngFor="let table of tableData; let i = index; trackBy: trackByPatientId" [ngClass]="{ 'urgent-row': table.urgency === 'URGENT' }">
                            <td>{{ i + 1 }}</td>

                            <!-- <td>
                              <input type="checkbox" [checked]="table.assignedF" (change)="assign(table.id)">
                            </td> -->

                            <td>{{ table.staffName ? table.staffName : '-' }}</td>

                            <td>
                              <ng-container [ngSwitch]="table.batchJobStatus">
                                <span *ngSwitchCase="'SUCCESS'" class="badge-soft badge-verified">Success</span>
                                <span *ngSwitchCase="'PENDING'" class="badge-soft badge-pending">Pending</span>
                                <span *ngSwitchCase="'FAILED'"
                                      class="badge-soft badge-backlog"
                                      matTooltip="{{ table.apiErrorMessage || 'No error details available' }}"
                                      matTooltipPosition="above"
                                      matTooltipClass="form-types-tooltip">
                  Failed
                </span>
                                <span *ngSwitchDefault class="text-muted">-</span>
                              </ng-container>
                            </td>

                            <td>
                              <div class="dropdown export-dropdown">
                                <button
                                  type="button"
                                  class="export-trigger"
                                  [disabled]="table.verification !== 'VERIFIED'"
                                  [attr.data-toggle]="table.verification === 'VERIFIED' ? 'dropdown' : null"
                                  [attr.aria-disabled]="table.verification !== 'VERIFIED'"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                  [title]="table.verification === 'VERIFIED' ? 'Export patient data' : 'Export is available only for verified patients'">
                                  <span class="export-trigger-icon">
                                    <i class="fa-solid fa-download"></i>
                                  </span>
                                  <span>Export</span>
                                  <i class="fa-solid fa-chevron-down export-trigger-chevron"></i>
                                </button>

                                <div class="dropdown-menu export-menu">
                                  <div class="export-menu-label">Download format</div>

                                  <button
                                    type="button"
                                    class="dropdown-item export-menu-item"
                                    (click)="exportData('excel', table.id, table.firstName ? table.firstName + ' ' + table.lastName : '-')">
                                    <span class="export-format-icon export-format-excel">
                                      <i class="fa-solid fa-file-excel"></i>
                                    </span>
                                    <span class="export-format-copy">
                                      <span class="export-format-title">Export as Excel</span>
                                      <span class="export-format-subtitle">Spreadsheet (.xlsx)</span>
                                    </span>
                                  </button>

                                  <button
                                    type="button"
                                    class="dropdown-item export-menu-item"
                                    (click)="exportData('pdf', table.id, table.firstName ? table.firstName + ' ' + table.lastName : '-')">
                                    <span class="export-format-icon export-format-pdf">
                                      <i class="fa-solid fa-file-pdf"></i>
                                    </span>
                                    <span class="export-format-copy">
                                      <span class="export-format-title">Export as PDF</span>
                                      <span class="export-format-subtitle">Document (.pdf)</span>
                                    </span>
                                  </button>
                                </div>
                              </div>
                            </td>

                            <td>
                              <ng-container [ngSwitch]="table.verification">
                                <span *ngSwitchCase="'VERIFIED'" class="badge-soft badge-verified">Verified</span>
                                <span *ngSwitchCase="'PENDING'" class="badge-soft badge-pending">In Progress</span>
                                <span *ngSwitchCase="'NOT_VERIFIED'" class="badge-soft badge-notverified">Not Verified</span>
                                <span *ngSwitchCase="'BACKLOG'" class="badge-soft badge-backlog">Backlog</span>
                                <span *ngSwitchCase="'UNASSIGNED'" class="badge-soft badge-unassigned">Unassigned</span>
                                <span *ngSwitchDefault class="text-muted">-</span>
                              </ng-container>
                            </td>

                  <td class="audit-review-status-cell">
                    <div *ngIf="table.auditChangesRequested === true; else noAuditChanges"
                         class="audit-review-flag"
                         [matTooltip]="table.auditChangesRequestedAt
                           ? ('Changes requested on ' + (table.auditChangesRequestedAt | date:'MMM d, y, h:mm a'))
                           : 'Changes requested by auditor'"
                         matTooltipPosition="above">
                      <span class="audit-review-flag-badge">
                        <i class="fa-solid fa-rotate-left" aria-hidden="true"></i>
                        Changes Requested
                      </span>
                      <small *ngIf="table.auditChangesRequestedAt" class="audit-review-flag-time">
                        {{ table.auditChangesRequestedAt | date:'MMM d, y' }}
                      </small>
                    </div>
                    <ng-template #noAuditChanges>
                      <span class="audit-review-no-flag" title="No audit changes requested">-</span>
                    </ng-template>
                  </td>
                            <td class="text-left fw-semibold">
                              <a [routerLink]="['details/', table.id]" [queryParams]="{ officeId: table.officeId, planCreation: table.planCreation }">
                                {{ table.firstName ? table.firstName + ' ' + table.lastName : '-' }}
                              </a>
                            </td>

                            <td>{{ table.dob ? (table.dob | date: 'MM/dd/yyyy') : '-' }}</td>

                            <td>
                              <a [routerLink]="['details/', table.id]" [queryParams]="{ officeId: table.officeId }">
                                {{ table.patientId ? table.patientId : '-' }}
                              </a>
                            </td>

                            <td>{{ table.formType ? table.formType : '-' }}</td>
                            <td>{{ table.insuranceType ? table.insuranceType : '-' }}</td>
                            <td>{{ table.payerName ? table.payerName : '-' }}</td>
                            <td>{{ table.careerName ? table.careerName : '-' }}</td>
                            <td>{{ table.insuranceId ? table.insuranceId : '-' }}</td>
                            <td>{{ table.memberId ? table.memberId : '-' }}</td>
                            <td>{{ table.subscriberDob ? (table.subscriberDob | date: 'MM/dd/yyyy') : '-' }}</td>
                            <td>{{ table.insurancePhone ? table.insurancePhone : '-' }}</td>
                            <td>{{ table.apptDate ? (table.apptDate | date: 'MM/dd/yyyy') : '-' }}</td>
                            <td>{{ table.apptTime ? table.apptTime : '-' }}</td>
                            <td>{{ table.providerName ? table.providerName : '-' }}</td>
                            <td>{{ table.officeName ? table.officeName : '-' }}</td>
                            <td>{{ table.groupNo ? table.groupNo : '-' }}</td>
                            <td>
                              {{ table.formFillTime ? formatTime(table.formFillTime) : '-' }}
                            </td>

                            <td>
                              <i *ngIf="table.active" class="fa-solid fa-square-check text-success"></i>
                              <i *ngIf="!table.active" class="fa-solid fa-square-check text-danger"></i>
                            </td>

                            <td>
                              <a title="Edit" [routerLink]="['details/', table.id]">
                                <i class="fa-solid fa-user-pen"></i>
                              </a>
                            </td>
                          </tr>
                          </tbody>

                          <tbody *ngIf="!tableData || tableData.length === 0">
                          <tr>
                            <td colspan="25" class="table-empty">No record found!</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>

                      <div *ngIf="tableData?.length !== 0" class="table-footer-controls d-flex justify-content-end align-items-start mt-3 px-3 pb-3">
                        <mat-paginator
                          [length]="totalRecord"
                          [pageIndex]="pagination.currentPage"
                          [pageSize]="pagination.size"
                          [pageSizeOptions]="[5, 10, 25, 100]"
                          aria-label="Select page"
                          showFirstLastButtons
                          color="warn"
                          (page)="pageChange($event)">
                        </mat-paginator>

                        <mat-form-field appearance="outline" class="page-selector ml-3">
                          <mat-label>Go to Page</mat-label>
                          <mat-select [(ngModel)]="pagination.currentPage" (selectionChange)="jumpToPage($event)">
                            <mat-option *ngFor="let page of totalPagesArray; trackBy: trackByPage" [value]="page - 1">
                              {{ page }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
            </div>
        </div>
    </div>
</div>
